export const PRIORITY_META = {
  CRITIQUE: { label: "Critique", bg: "bg-red-50", text: "text-red-600", border: "border-red-200", dot: "bg-red-500" },
  IMPORTANT: { label: "Important", bg: "bg-orange-50", text: "text-orange-600", border: "border-orange-200", dot: "bg-orange-500" },
  AMELIORER: { label: "À améliorer", bg: "bg-yellow-50", text: "text-yellow-700", border: "border-yellow-200", dot: "bg-yellow-500" },
  BON: { label: "Bon", bg: "bg-green-50", text: "text-green-700", border: "border-green-200", dot: "bg-green-500" },
  EXCELLENT: { label: "Excellent", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500" },
  NON_MESURE: { label: "Non mesuré", bg: "bg-slate-100", text: "text-slate-500", border: "border-slate-200", dot: "bg-slate-400" },
  NON_VERIFIABLE: { label: "Non vérifiable", bg: "bg-slate-100", text: "text-slate-500", border: "border-slate-200", dot: "bg-slate-400" },
  NON_APPLICABLE: { label: "Non applicable", bg: "bg-slate-50", text: "text-slate-400", border: "border-slate-200", dot: "bg-slate-300" },
};

export const CONFIDENCE_LABEL = { COMPLETE: "Complète", PARTIAL: "Partielle", LOW: "Faible", NONE: "Aucune" };
export const ARCHIVE_REASON_LABEL = { not_applicable: "Non pertinent pour le secteur actuel", not_measured: "Donnée plus mesurée / non vérifiable", duplicate: "Doublon fusionné", superseded: "Remplacée" };

export const IMPACT_LABEL = { high: "Impact élevé", medium: "Impact moyen", low: "Impact faible" };

export function scoreColor(score) {
  if (score == null) return "text-slate-400";
  if (score >= 75) return "text-emerald-600";
  if (score >= 60) return "text-yellow-600";
  if (score >= 40) return "text-orange-500";
  return "text-red-500";
}

export function scoreStroke(score) {
  if (score == null) return "#94a3b8";
  if (score >= 75) return "#10b981";
  if (score >= 60) return "#eab308";
  if (score >= 40) return "#f97316";
  return "#ef4444";
}

export const PILLAR_ICONS = {
  site_internet: "Globe", performance: "Gauge", seo: "Search", seo_local: "MapPin",
  gbp: "Building2", reputation: "Star", reseaux_sociaux: "Share2", conversion: "MousePointerClick",
  presence: "Radar", concurrence: "Swords",
};
